export default __webpack_public_path__ + "static/media/eduImgWhite.433f9250.svg";